import React, { useContext, useState, useEffect } from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './css/style.css';
import './css/responsive.css';
import Lottie from 'react-lottie-player';
import mouseAnimation from './images/MouseAnimation.json';
import LogoDigital from './images/2Digital.png';
import { useMediaQuery, Box } from '@mui/material';// Importa el CircularProgress de Material-UI
import { FaWhatsapp } from 'react-icons/fa'; // Librería para íconos
import Tooltip from '@mui/material/Tooltip';
import logoApp from '../img/2logoCheck.png';

const PoliticasFeVida = () => {
    const isMobile = useMediaQuery('(max-width:450px)'); // Detectar si es una pantalla móvil

    useEffect(() => {
        // Crear el elemento <link> para el CSS de Bootstrap
        const bootstrapCss = document.createElement('link');
        bootstrapCss.rel = 'stylesheet';
        bootstrapCss.href = 'https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css';
        document.head.appendChild(bootstrapCss);

        // Crear el elemento <script> para jQuery (sin async)
        const jqueryScript = document.createElement('script');
        jqueryScript.src = 'https://code.jquery.com/jquery-3.5.1.min.js';
        document.body.appendChild(jqueryScript);

        // Crear el elemento <script> para Popper.js
        const popperScript = document.createElement('script');
        popperScript.src = 'https://cdn.jsdelivr.net/npm/@popperjs/core@2.5.4/dist/umd/popper.min.js';
        popperScript.async = true;
        document.body.appendChild(popperScript);

        // Crear el elemento <script> para el JS de Bootstrap
        const bootstrapScript = document.createElement('script');
        bootstrapScript.src = 'https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/js/bootstrap.min.js';
        jqueryScript.onload = () => {
            document.body.appendChild(bootstrapScript);
        };

        // Limpieza de los scripts y estilos cuando se navegue a /Login
        /*if (location.pathname === '/Login') {
            document.head.removeChild(bootstrapCss);
            document.body.removeChild(jqueryScript);
            document.body.removeChild(popperScript);
            if (document.body.contains(bootstrapScript)) {
                document.body.removeChild(bootstrapScript);
            }
        }*/

        // Cleanup al desmontar el componente
        return () => {
            // Limpia los elementos cuando el componente se desmonte
            /*document.head.removeChild(bootstrapCss);
            document.body.removeChild(jqueryScript);
            document.body.removeChild(popperScript);
            if (document.body.contains(bootstrapScript)) {
                document.body.removeChild(bootstrapScript);
            }*/
        };
    }, [/*location.pathname*/]); // Se ejecuta cuando la ruta cambia

    return (
        <>
            <section id="inicio">
                {/* header section starts */}
                <header className="header_section" style={{ backgroundColor: '#72D2DA' }}>
                    <div className="container-fluid">
                        <nav className="navbar navbar-expand-lg custom_nav-container">
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Lottie loop animationData={mouseAnimation} play style={{ width: isMobile ? '30px' : '50px', height: 'auto' }} />
                                <a className="navbar-brand" href="#">
                                    <div className="brand_text">
                                        <img src={LogoDigital} alt="Logo Digital" style={{ width: isMobile ? '150px' : '250px', height: 'auto', marginLeft: 10 }} />
                                    </div>
                                </a>
                            </div>

                        </nav>
                    </div>
                </header>
                {/* end header section */}



                {/* SERVICIOS DISPONIBLES */}
                <section id="servicios-disponibles">
                    <section className="service_section layout_padding">
                        <div className="container">
                            <div className="heading_container">
                                <Box display="flex" justifyContent="center" alignItems="center" mb={3}>
                                    <img
                                        src={logoApp}
                                        alt="Logo App"
                                        style={{ width: '120px', height: 'auto' }}
                                    />
                                </Box>
                                <h2>🛡️ Política de Privacidad</h2>
                                <p><strong>Aplicación móvil: Prueba de Sobrevivencia 2025</strong></p>
                                <p>En INJUPEMP, respetamos y protegemos la privacidad de nuestros afiliados, pensionados y beneficiarios. Esta política describe cómo recopilamos, utilizamos y protegemos los datos personales recolectados a través de la aplicación móvil Prueba de Sobrevivencia 2025, desarrollada con el fin de facilitar la validación digital del cumplimiento del requisito anual de fe de vida.</p>

                                <div style={{ textAlign: 'left' }}>
                                    <h5>Información que recopilamos</h5>
                                    <p>
                                        • Datos de identificación: nombre completo, número de identidad, código de afiliado o pensionado.<br />
                                        • Captura biométrica facial para validación de identidad.<br />
                                        • Fecha y hora de uso.
                                    </p>

                                    <h5>Finalidad del tratamiento de datos</h5>
                                    <p>
                                        • Verificar la identidad del usuario mediante reconocimiento facial.<br />
                                        • Registrar digitalmente el cumplimiento del requisito de fe de vida.<br />
                                        • Garantizar la trazabilidad y transparencia del proceso.
                                    </p>

                                    <h5>Base legal</h5>
                                    <p>
                                        • En cumplimiento de los artículos 60 y 77 de la Ley de INJUPEMP, se realizará la Prueba de Sobrevivencia y Reevaluación de Invalidez.<br />
                                        • Las disposiciones vigentes sobre protección de datos en Honduras.
                                    </p>

                                    <h5>Derechos del titular de los datos</h5>
                                    <p>
                                        • Acceder a sus datos personales.<br />
                                        • Solicitar la corrección de datos inexactos.<br />
                                        • Solicitar información sobre el tratamiento de sus datos.
                                    </p>
                                </div>

                            </div>
                        </div>
                    </section>
                </section>

                {/* Fin Servicios Disponibles */}
                <div className="footer_container">
                    <section className="info_section">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-6 col-lg-3">
                                    <div className="info_detail">
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                                            <h4 style={{ marginBottom: '10px' }}>INJUPEMP Conectados</h4>
                                            <Lottie loop animationData={mouseAnimation} play style={{ width: isMobile ? '30px' : '50px', height: 'auto' }} />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6 col-lg-3 mb-0 ml-auto">
                                    <div className="info_contact">
                                        <h4>
                                            Contacto y Soporte
                                        </h4>
                                        <div className="contact_link_box">
                                            <a href="https://maps.app.goo.gl/pmvUaL48qTr24pPY6" target='_blank'>
                                                <i className="fa-solid fa-location-dot"></i>
                                                <span>
                                                    Loma Linda Norte, Ave La FAO, Tegucigalpa D.C.
                                                </span>
                                            </a>
                                            <a href="tel:+50422901900">
                                                <i className="fa fa-phone" aria-hidden="true"></i>
                                                <span>
                                                    +504 2290-1900 OPCIÓN #3
                                                </span>
                                            </a>
                                            <a href="mailto:info@injupemp.gob.hn">
                                                <i className="fa fa-envelope" aria-hidden="true"></i>
                                                <span>
                                                    info@injupemp.gob.hn
                                                </span>
                                            </a>

                                        </div>
                                    </div>
                                    <div className="info_social">
                                        <a href="https://www.facebook.com/injupemp/" target="_blank">
                                            <i className="fa-brands fa-facebook" aria-hidden="true"></i>
                                        </a>
                                        <a href="https://x.com/injupemp?lang=en" target="_blank">
                                            <i className="fa-brands fa-x-twitter" aria-hidden="true"></i>
                                        </a>
                                        <a href="https://www.youtube.com/@injupemphonduras1770" target="_blank">
                                            <i className="fa-brands fa-youtube" aria-hidden="true"></i>
                                        </a>
                                        <a href="https://www.instagram.com/injupempHn/?hl=en" target="_blank">
                                            <i className="fa-brands fa-instagram" aria-hidden="true"></i>
                                        </a>
                                        {<a href="https://wa.link/kbcxjr" target="_blank">
                                            <i className="fa-brands fa-whatsapp" aria-hidden="true"></i>
                                        </a>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    {<Tooltip title="Ir al ChatBot INJUPEMP Virtual" placement='left' arrow>
                        <a
                            href="https://wa.link/kbcxjr"
                            className="btn-wsp"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FaWhatsapp className="icono" />
                        </a>
                    </Tooltip>}

                    <footer className="footer_section">
                        <div className="container">
                            <p>
                                <a href="https://www.injupemp.gob.hn/">INJUPEMP</a>
                                &copy; <span id="displayYear"></span> Todos los derechos reservados
                            </p>
                        </div>
                    </footer>
                </div>

                <script src="js/jquery-3.4.1.min.js"></script>
                <script src="https://cdn.jsdelivr.net/npm/popper.js@1.16.0/dist/umd/popper.min.js"
                    integrity="sha384-Q6E9RHvbIyZFJoft+2mJbHaEWldlvI9IOYy5n3zV9zzTtmI3UksdQRVvoxMfooAo" crossOrigin="anonymous">
                </script>
                <script src="js/bootstrap.js"></script>
                <script src="js/custom.js"></script>
                <script
                    src={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ""}`}
                    async
                ></script>
                <script src="js/scrolling-nav.js"></script>

            </section>
        </>
    );
};

export default PoliticasFeVida;

